export const reportComoDataTypes = {
  GET_REPORT_COMO_DATA: 'GET_REPORT_COMO_DATA',
  SET_REPORT_COMO_DATA_FILTERS: 'SET_REPORT_COMO_DATA_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL',
};